/**
 * Multi-variant Add to cart:
 * The button grows up to the product name and that lower area becomes the
 * condition list. The cover stays put. The list stays inside the tile.
 */
(function () {
  if (customElements.get('ri-choose-options')) return;

  class RiChooseOptions extends HTMLElement {
    constructor() {
      super();
      this._bound = false;
      this._hideTimer = 0;
    }

    connectedCallback() {
      if (this.classList.contains('is-sheet')) return;
      this.card = this.closest('.ri-catalog-card') || this.closest('.card-wrapper') || this.card;
      this.placeInDetails();
      this.bindOnce();
    }

    bindOnce() {
      if (this._bound) return;
      this._bound = true;

      this.querySelectorAll('[data-ri-choose-close]').forEach(
        function (btn) {
          btn.addEventListener('click', this.close.bind(this));
        }.bind(this)
      );

      if (this.card) {
        this.card.addEventListener(
          'click',
          function (evt) {
            var openBtn = evt.target.closest('[data-ri-choose-open]');
            if (!openBtn || !this.card.contains(openBtn)) return;
            if (openBtn.closest('ri-choose-options')) return;
            evt.preventDefault();
            evt.stopPropagation();
            this.open(openBtn);
          }.bind(this)
        );
      }

      this.addEventListener('click', function (evt) {
        if (evt.target.closest('[data-ri-atc-remove], [data-ri-atc-plus]')) return;
        evt.stopPropagation();
      });
    }

    placeInDetails() {
      if (!this.card) return;
      var card = this.card.querySelector(':scope > .card') || this.card;
      var host = card.querySelector(':scope > .card__content') || card;
      if (host && this.parentElement !== host) host.appendChild(this);
    }

    shouldSheet() {
      return false;
    }

    fitSheet() {
      var vv = window.visualViewport;
      if (!vv) return;
      this.style.top = vv.offsetTop + 'px';
      this.style.height = vv.height + 'px';
      this.style.left = '0';
      this.style.right = '0';
      this.style.bottom = 'auto';
    }

    openSheet(opener) {
      var self = this;
      document.querySelectorAll('ri-choose-options.is-open').forEach(function (el) {
        if (el !== self) el.close();
      });
      this.classList.add('is-sheet', 'is-open');
      if (this.parentElement !== document.body) document.body.appendChild(this);
      this.classList.remove('is-closing', 'is-preparing');
      this.hidden = false;
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      this.fitSheet();
      if (!this._sheetLocked && window.RIScrollLock) {
        window.RIScrollLock.lock();
        this._sheetLocked = true;
      }
      if (typeof trapFocus === 'function') trapFocus(this, this.querySelector('[data-ri-choose-close]') || this);
      if (opener) opener.setAttribute('aria-expanded', 'true');
      if (!this._sheetFit) {
        this._sheetFit = this.fitSheet.bind(this);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', this._sheetFit);
        if (window.visualViewport) window.visualViewport.addEventListener('scroll', this._sheetFit);
      }
      if (!this._sheetKey) {
        this._sheetKey = function (event) {
          if (event.key === 'Escape') self.close();
        };
        this.addEventListener('keydown', this._sheetKey);
      }
      if (!this._sheetBackdrop) {
        this._sheetBackdrop = function (event) {
          if (event.target === self) self.close();
        };
        this.addEventListener('click', this._sheetBackdrop);
      }
    }

    closeSheet() {
      this.classList.remove('is-open', 'is-sheet', 'is-closing', 'is-preparing');
      this.removeAttribute('role');
      this.removeAttribute('aria-modal');
      this.style.top = '';
      this.style.height = '';
      this.style.left = '';
      this.style.right = '';
      this.style.bottom = '';
      this.hidden = true;
      if (this._sheetFit && window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this._sheetFit);
        window.visualViewport.removeEventListener('scroll', this._sheetFit);
      }
      this._sheetFit = null;
      if (this._sheetLocked && window.RIScrollLock) {
        window.RIScrollLock.unlock();
        this._sheetLocked = false;
      }
      if (typeof removeTrapFocus === 'function') {
        var opener = this.card && this.card.querySelector('[data-ri-choose-open]');
        removeTrapFocus(opener || null);
      }
      var openBtn = this.card && this.card.querySelector('[data-ri-choose-open]');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      if (this.card) this.card.classList.remove('ri-choose-open');
      this.placeInDetails();
    }

    open(opener) {
      if (this.shouldSheet()) {
        this.openSheet(opener);
        return;
      }
      if (this.classList.contains('is-sheet')) this.closeSheet();
      var self = this;
      document.querySelectorAll('ri-choose-options.is-open').forEach(function (el) {
        if (el !== self) el.close();
      });
      this.placeInDetails();
      this.classList.remove('is-closing');
      if (this.card) this.card.classList.remove('is-atc-ready');
      this.releaseHeading();
      if (this._onEnd) {
        this.removeEventListener('transitionend', this._onEnd);
        this._onEnd = null;
      }
      var anchorEl = opener && opener.closest ? opener.closest('.ri-card-atc__switch') || opener : opener;
      this.anchor(anchorEl);
      window.clearTimeout(this._hideTimer);
      this.hidden = false;
      if (this.card) this.card.classList.add('ri-choose-open');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open', 'is-preparing');
      void this.offsetWidth;
      var started = false;
      var start = function () {
        if (started) return;
        started = true;
        self.classList.remove('is-preparing');
        self.fitVariants();
      };
      window.requestAnimationFrame(start);
      window.setTimeout(start, 32);
      this.watchFit();
    }

    watchFit() {
      var self = this;
      if (!this._onResize) {
        this._onResize = function () {
          if (!self.classList.contains('is-open')) return;
          self.fitVariants();
        };
        window.addEventListener('resize', this._onResize);
      }
    }

    clearVariantFit() {
      this.classList.remove('is-one-line', 'is-snug-scroll');
      this.style.removeProperty('--ri-variant-gap');
      this.style.removeProperty('--ri-variant-min');
      this.style.removeProperty('--ri-variant-pad');
      this.style.removeProperty('--ri-variant-scale');
    }

    nameCutOff() {
      var names = this.querySelectorAll('.ri-choose-options__variant-name');
      for (var i = 0; i < names.length; i++) {
        var range = document.createRange();
        range.selectNodeContents(names[i]);
        if (range.getBoundingClientRect().width > names[i].clientWidth + 1) return true;
        var price = names[i].parentElement && names[i].parentElement.querySelector('.ri-choose-options__variant-price');
        if (!price) continue;
        var edge = names[i].parentElement.getBoundingClientRect().right;
        if (price.getBoundingClientRect().right > edge + 1) return true;
      }
      return false;
    }

    /* Shrink type so a name is fully visible. Stop while it is still readable. */
    shrinkNamesToFit() {
      var scale = parseFloat(this.style.getPropertyValue('--ri-variant-scale')) || 1;
      var steps = 0;
      while (this.nameCutOff() && scale > 0.72 && steps < 10) {
        scale = Math.round((scale - 0.04) * 100) / 100;
        this.style.setProperty('--ri-variant-scale', String(scale));
        steps += 1;
      }
      return !this.nameCutOff();
    }

    namePastTwoLines() {
      var names = this.querySelectorAll('.ri-choose-options__variant-name');
      for (var i = 0; i < names.length; i++) {
        var lh = parseFloat(getComputedStyle(names[i]).lineHeight);
        if (!lh) continue;
        if (names[i].getBoundingClientRect().height > lh * 2 + 2) return true;
      }
      return false;
    }

    /* A long name may use two lines. Shrink only when it would take a third. */
    capAtTwoLines() {
      var scale = parseFloat(this.style.getPropertyValue('--ri-variant-scale')) || 1;
      var steps = 0;
      while (this.namePastTwoLines() && scale > 0.72 && steps < 10) {
        scale = Math.round((scale - 0.04) * 100) / 100;
        this.style.setProperty('--ri-variant-scale', String(scale));
        steps += 1;
      }
    }

    /* A list that already fits stays as it is. A list that would scroll keeps
       two lines when that still fits, then shrinks the type so the name stays
       whole. Text is never cut off. */
    fitVariants() {
      if (this._fitting) return;
      var list = this.querySelector('.ri-choose-options__variants');
      if (!list || !this.classList.contains('is-open')) return;
      this._fitting = true;
      this.clearVariantFit();

      var overflows = function () {
        return list.scrollHeight > list.clientHeight + 1;
      };

      if (!overflows()) {
        this.capAtTwoLines();
        this._fitting = false;
        return;
      }

      var pads = [0.38, 0.32, 0.26];
      var mins = [3.3, 3, 2.7];
      var gaps = [0.32, 0.26, 0.22];
      for (var i = 0; i < pads.length; i++) {
        this.style.setProperty('--ri-variant-pad', pads[i] + 'rem');
        this.style.setProperty('--ri-variant-min', mins[i] + 'rem');
        this.style.setProperty('--ri-variant-gap', gaps[i] + 'rem');
        if (!overflows()) {
          this.capAtTwoLines();
          this._fitting = false;
          return;
        }
      }

      this.classList.add('is-one-line');
      if (this.shrinkNamesToFit() && !overflows()) {
        this._fitting = false;
        return;
      }

      /* Two lines, full words, and a scrollbar if the tile is still too short. */
      this.clearVariantFit();
      this.classList.add('is-snug-scroll');
      this.capAtTwoLines();
      this.shrinkNamesToFit();
      this._fitting = false;
    }

    anchor(opener) {
      var host = this.parentElement;
      if (!host || !opener) return;
      var hr = host.getBoundingClientRect();
      var br = opener.getBoundingClientRect();
      this.style.setProperty('--ri-choose-top', Math.max(0, br.top - hr.top) + 'px');
      this.style.setProperty('--ri-choose-left', Math.max(0, br.left - hr.left) + 'px');
      this.style.setProperty('--ri-choose-w', br.width + 'px');
      this.style.setProperty('--ri-choose-h', br.height + 'px');
    }

    close() {
      if (this.classList.contains('is-sheet')) {
        this.closeSheet();
        return;
      }
      var self = this;
      if (!this.classList.contains('is-open')) return;
      var sw = this.card && this.card.querySelector('[data-ri-choose-switch]');
      if (sw) this.anchor(sw);
      this.classList.remove('is-preparing');
      if (this.card) this.card.classList.add('is-atc-ready');
      this.classList.add('is-closing');
      this.classList.remove('is-open');
      var openBtn = this.card && this.card.querySelector('[data-ri-choose-open]');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      var finish = function () {
        if (self.classList.contains('is-open')) return;
        self.classList.remove('is-closing');
        self.clearVariantFit();
        self.releaseHeading();
        self.hidden = true;
        if (self.card) {
          self.card.classList.remove('ri-choose-open');
          self.card.classList.remove('is-atc-ready');
        }
        if (self._onEnd) {
          self.removeEventListener('transitionend', self._onEnd);
          self._onEnd = null;
        }
      };
      if (this._onEnd) this.removeEventListener('transitionend', this._onEnd);
      var onEnd = function (evt) {
        if (evt.target !== self) return;
        if (evt.propertyName !== 'clip-path') return;
        finish();
      };
      this._onEnd = onEnd;
      this.addEventListener('transitionend', onEnd);
      window.clearTimeout(this._hideTimer);
      this._hideTimer = window.setTimeout(finish, 460);
    }

    parkHeading(heading, sw) {
      var host = this.parentElement;
      if (!host) return;
      var hostRect = host.getBoundingClientRect();
      var start = heading.getBoundingClientRect();
      var end = sw.getBoundingClientRect();
      var ease = 'cubic-bezier(0.2, 0.7, 0.2, 1)';
      this._parkedHeading = heading;
      host.appendChild(heading);
      heading.style.transition = 'none';
      heading.style.position = 'absolute';
      heading.style.left = start.left - hostRect.left + 'px';
      heading.style.top = start.top - hostRect.top + 'px';
      heading.style.width = start.width + 'px';
      heading.style.height = start.height + 'px';
      heading.style.margin = '0';
      heading.style.zIndex = '7';
      heading.style.display = 'flex';
      heading.style.alignItems = 'center';
      heading.style.justifyContent = 'center';
      heading.style.whiteSpace = 'nowrap';
      heading.style.pointerEvents = 'none';
      heading.style.color = '#000';
      void heading.offsetWidth;
      var applied = false;
      var apply = function () {
        if (applied) return;
        applied = true;
        heading.style.transition =
          'top 0.22s ' + ease + ', left 0.22s ' + ease + ', width 0.22s ' + ease + ', height 0.22s ' + ease;
        heading.style.left = end.left - hostRect.left + 'px';
        heading.style.top = end.top - hostRect.top + 'px';
        heading.style.width = end.width + 'px';
        heading.style.height = end.height + 'px';
      };
      window.requestAnimationFrame(apply);
      window.setTimeout(apply, 32);
    }

    releaseHeading() {
      var heading = this._parkedHeading || this.querySelector('.ri-choose-options__heading');
      var bar = this.querySelector('.ri-choose-options__bar');
      this._parkedHeading = null;
      if (!heading) return;
      if (bar && heading.parentElement !== bar) {
        var closeBtn = bar.querySelector('.ri-choose-options__close');
        if (closeBtn) bar.insertBefore(heading, closeBtn);
        else bar.insertBefore(heading, bar.firstChild);
      }
      heading.style.cssText = '';
    }
  }

  customElements.define('ri-choose-options', RiChooseOptions);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || (event.source !== 'product-form' && event.source !== 'ri-card-atc')) return;
      if (event.cartData && event.cartData.status) return;
      document.querySelectorAll('ri-choose-options.is-sheet.is-open').forEach(function (sheet) {
        sheet.close();
      });
    });
  }

  var sheetMq = window.matchMedia('(min-width: 990px)');
  sheetMq.addEventListener('change', function () {
    if (!sheetMq.matches) return;
    document.querySelectorAll('ri-choose-options.is-sheet.is-open').forEach(function (sheet) {
      sheet.close();
    });
  });
})();
